// Guided tours point at the preview's Edit / Share buttons through this
// `data-tour` anchor (see `src/modules/product-updates/tours/tourTypes.ts`).
// Kept out of `PreviewActions.tsx` so tour definitions import no UI code.
export const REPORT_PREVIEW_ACTIONS_ANCHOR = 'report-preview-actions';

// The "Enable this section" button over a hidden step's content.
export const REPORT_ENABLE_SECTION_ANCHOR = 'report-enable-section';

// One per step in the report editor's step list (with its show/hide eye).
export const reportStepAnchor = (pageId: string) => `report-step-${pageId}`;

// The "Automatically" / "Manually" buttons of the comparables steps.
export const REPORT_SELECTION_ACTIONS_ANCHOR = 'report-selection-actions';

// The collapsible "Settings" panel of the comparable listings step.
export const COMPARABLES_SETTINGS_ANCHOR = 'cma-comparables-settings';

// The collapsible "Settings" panel of the comparable transactions step.
export const TRANSACTIONS_SETTINGS_ANCHOR = 'cma-transactions-settings';
